import { cn } from '@/lib/utils';

/**
 * Single thumb-zone contract for Field Mode.
 * FieldActionBar + FloatingActionButton sit at `bottom-24` above UnifiedMobileNav.
 * Content must clear that band on mobile; desktop uses normal padding.
 */

/** Tailwind class: fixed FAB / FieldActionBar vertical offset above nav. */
export const FIELD_THUMB_BOTTOM = 'bottom-24' as const;

/** Main scroll padding that clears UnifiedMobileNav (no FieldActionBar on page). */
export const FIELD_CONTENT_PAD = 'pb-24 pb-safe md:pb-8' as const;

/** Extra pad when a FieldActionBar is mounted (nav + bar). */
export const FIELD_CONTENT_PAD_WITH_ACTIONS = 'pb-40 pb-safe md:pb-8' as const;

type FieldThumbSpacerProps = {
  /** When true, reserves space for FieldActionBar + nav; otherwise nav only. */
  withActions?: boolean;
  className?: string;
};

/**
 * Invisible spacer so list/grid content clears the thumb band on mobile.
 * Prefer this over ad-hoc `h-28` / `pb-20` per station.
 */
export function FieldThumbSpacer({ withActions = true, className }: FieldThumbSpacerProps) {
  return (
    <div
      aria-hidden
      data-testid="field-thumb-spacer"
      className={cn('md:hidden shrink-0', withActions ? 'h-36' : 'h-20', className)}
    />
  );
}
